<script lang="ts">
  import PdpButton from './PdpButton.svelte';
</script>

<div class="liveVideo-container">
  <div class="liveVideo-inner">
    <div class="liveVideo-title1">Still deciding?</div>
    <div class="liveVideo-title2">Shop with an expert!</div>
    <p class="liveVideo-text">
      Connect live with a product expert over chat, voice or video. Don't have time at the moment? We can also schedule
      an appointment for you.
    </p>
    <div class="liveVideo-actions">
      <div class="liveVideo-actions-status">Available</div>
      <div class="js-pdp-live-video">
        <PdpButton label="Start a video call" type="secondary" variant="solid" />
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .liveVideo {
    &-container {
      padding: 24px 16px;
      text-align: center;
      height: 376px;
      background: url('https://cdn.extra.com/ImagesSections/ImagesSections/hybris/new_ui_ux/banners/liveVideo-mob.png')
        no-repeat;
      color: $primary-white;
      font-size: 14px;
      @include desktop-min-width {
        height: 394px;
        background: url('https://cdn.extra.com/ImagesSections/ImagesSections/hybris/new_ui_ux/banners/liveVideo-desktop.png')
          no-repeat;
        padding: 80px 48px 0;
        text-align: left;
        margin-top: 80px;
      }
    }
    &-inner {
      @include desktop-min-width {
        width: 40%;
      }
    }
    &-title1 {
      color: $color-yellow;
      text-transform: uppercase;
    }
    &-title2 {
      font-size: 20px;
      margin-top: 4px;
      margin-bottom: 12px;
      @include desktop-min-width {
        font-size: 36px;
      }
    }

    &-text {
      color: $primary-white;
      margin: 0;
      @include desktop-min-width {
        margin: 18px 0 50px;
      }
    }
    &-actions {
      display: flex;
      align-items: center;
      flex-direction: column-reverse;
      @include desktop-min-width {
        flex-direction: row;
      }
      &-status {
        margin: 18px 0;
        position: relative;
        padding-left: 22px;
        order: 1;
        text-transform: uppercase;
        @include desktop-min-width {
          order: 2;
          margin-left: 40px;
        }
        &::before {
          position: absolute;
          width: 14px;
          height: 14px;
          background: $color-green;
          left: 0;
          border-radius: 100px;
          content: '';
        }
      }
    }
  }
</style>
